import type { ApiError } from './api-client'
import { t, type Lang } from './i18n'

// Map server error codes + HTTP status → user-facing message.
export function errorToMessage(err: ApiError, lang: Lang): string {
  switch (err.error) {
    case 'turnstile_failed':
      return t(lang, 'error.turnstile')
    case 'rate_limited':
      return t(lang, 'error.rate_limited')
    case 'invalid_input':
    case 'invalid_json':
      return t(lang, 'error.invalid_input')
    case 'network':
      return t(lang, 'error.network')
    default:
      return t(lang, 'error.internal')
  }
}
